module.exports = __webpack_public_path__ + "img/Male_Anterior_PaperDoll.a3fc6a8f.png";